// extracted by mini-css-extract-plugin
export var checked = "VariantItem-module--checked--c4ff0";
export var input = "VariantItem-module--input--d0350";
export var radioButton = "VariantItem-module--radioButton--fb942";
export var variantContainer = "VariantItem-module--variantContainer--49b6e";